// Write your JS code here
import {Component} from 'react'
import './index.css'

class BlogItem extends Component {
  render() {
    const {eachBlog} = this.props
    console.log(eachBlog.title)
    return (
      <li>
        <div>
          <div className="name-container">
            <h1 className="name1">{eachBlog.title}</h1>
            <p>{eachBlog.publishedDate}</p>
          </div>
          <p>{eachBlog.description}</p>
        </div>
      </li>
    )
  }
}

export default BlogItem

// final step
